/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2017 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 * */
import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

/**
 * A React component for close icon.
 *
 * @author Ramani Govindaraju
 */
const Close = props => (
  <SvgIcon viewBox="0 0 18 18" {...props}>
    <path
      d="M9.928 9l7.879-7.879a.657.657 0 0 0-.928-.929l-7.88 7.88L1.12.192a.657.657
      0 0 0-.928.93L8.071 9 .192 16.879a.657.657 0 0 0 .928.929L9 9.928l7.879
      7.88a.654.654 0 0 0 .928 0 .657.657 0 0 0 0-.93L9.928 9z"
    />
  </SvgIcon>
);

export default Close;



// WEBPACK FOOTER //
// ./src/js/icons/Close.jsx